@if (loading) {
  <div class="schedules-skeleton">
    @for (i of [1,2,3,4]; track i) {
      <div class="skeleton-schedule-item">
        <div class="skeleton-schedule-header">
          <div class="skeleton-avatar"></div>
          <div class="skeleton-title-block">
            <div class="skeleton-name"></div>
            <div class="skeleton-sub"></div>
          </div>
          <div class="skeleton-badge"></div>
        </div>
        <div class="skeleton-stats">
          <div class="skeleton-stat"></div>
          <div class="skeleton-stat"></div>
          <div class="skeleton-stat"></div>
        </div>
      </div>
    }
  </div>
} @else if (schedules.length === 0) {
  <div class="empty-state">
    <mat-icon class="empty-icon">inbox</mat-icon>
    <h3>{{ emptyMessage }}</h3>
  </div>
} @else {
  <div class="campaigns-list">
    @for (s of schedules; track s.id) {
      <div
        class="campaign-item clickable"
        [class.aired-box]="s.airedtimestamp"
        [class.delayed-box]="isDelayedAir(s)"
        [class.locked-schedule]="isScheduleLocked(s)"
        [class.preemptible-schedule]="isPreemptiblePromo(s)"
        (click)="viewDetails(s); $event.stopPropagation()"
      >
        <div class="campaign-header">
          <div class="campaign-header-main">
            <h2>{{ s.station_name || s.station_call_sign || ('Station #' + s.stationid) }}</h2>
            <div class="sub">
              Schedule #{{ s.id }} • {{ s.scheduledtime ? (s.scheduledtime | date:'medium') : 'Not scheduled' }}
            </div>
          </div>
          <div class="campaign-header-badges">
            @if (isPreemptiblePromo(s)) {
              <span class="badge badge-preemptible">Preemptible</span>
            }
            @if (isScheduleLocked(s)) {
              <span class="badge badge-locked">Locked day</span>
            }
            <span
              class="badge"
              [class.badge-aired]="s.airedtimestamp"
              [class.badge-yes]="!s.airedtimestamp && s.is_auto_fill"
              [class.badge-no]="!s.airedtimestamp && !s.is_auto_fill"
            >
              {{ s.airedtimestamp ? ('Aired at ' + (s.airedtimestamp | date:'short')) : 'Yet to be aired' }}
            </span>
            @if (isDelayedAir(s)) {
              <span
                class="badge badge-aired-delayed"
                matTooltip="Aired outside scheduled window (±30 min)"
                matTooltipPosition="above">
                Delayed air
              </span>
            }
          </div>
        </div>
        <div class="campaign-stats">
          @if (showCustomerInfo && scheduleCustomer(s); as customer) {
          <div class="stat customer-stat">
            <div class="stat-label">{{ customer.label }}</div>
            <div class="stat-value">{{ customer.value }}</div>
          </div>
          }
          <div class="stat">
            <div class="stat-label">Recording</div>
            <div class="stat-value">{{ (s.recording_name || ('#' + (s.recordingid || '-'))) | titlecase }}</div>
          </div>
          <div class="stat">
            <div class="stat-label">Impressions</div>
            <div class="stat-value">{{ s.impressions || 0 }}</div>
          </div>
          <div class="stat">
            <div class="stat-label">Cost</div>
            <div class="stat-value">$ {{ spotCost(s) | number:'1.2-2' }}</div>
          </div>
        </div>
        @if (scheduleAudioUrl(s)) {
          <div class="schedule-audio" (click)="$event.stopPropagation()">
            <audio [src]="scheduleAudioUrl(s)!" controls preload="metadata"></audio>
          </div>
        }
      </div>
    }
  </div>

  @if (showPagination) {
    <div class="pagination">
      <button
        type="button"
        class="btn-secondary btn-sm btn-icon-nav"
        (click)="pageChange.emit(0)"
        [disabled]="offset <= 0"
        title="First Page"
        aria-label="First page">
        <mat-icon aria-hidden="true">first_page</mat-icon>
      </button>
      <button
        type="button"
        class="btn-secondary btn-sm"
        (click)="pageChange.emit(offset - limit)"
        [disabled]="offset <= 0">
        <mat-icon aria-hidden="true">chevron_left</mat-icon>
        Prev
      </button>
      <span class="page-info">{{ offset + 1 }} - {{ Math.min(offset + limit, total) }} of {{ total }}</span>
      <button
        type="button"
        class="btn-secondary btn-sm"
        (click)="pageChange.emit(offset + limit)"
        [disabled]="offset + limit >= total">
        Next
        <mat-icon aria-hidden="true">chevron_right</mat-icon>
      </button>
      <button
        type="button"
        class="btn-secondary btn-sm btn-icon-nav"
        (click)="pageChange.emit(Math.floor((total - 1) / limit) * limit)"
        [disabled]="offset + limit >= total"
        title="Last Page"
        aria-label="Last page">
        <mat-icon aria-hidden="true">last_page</mat-icon>
      </button>
    </div>
  }
}
